import React, { useEffect, useState } from "react";
import { useNavigate, useParams, useLocation, Link } from "react-router-dom";
import Header from "../components/Header";
import NotFoundPage from "./NotFoundPage";
import { useAuth } from "../context/AuthContext";
import { obterParceiroBolsa, meuInteresseBolsa, pedirInteresseBolsa, urlApi } from "../services/api";
import { NumerosParceiro, AvaliacoesParceiro, AvaliarParceiro, RetirarAutorizacao, AgendaAulaGratis } from "../components/ParceiroConfianca";

// 22/10/2026: a mesma página serve ao PROFESSOR autônomo (tipo "prof", aula experimental grátis) do cadastro novo,
// com logotipo e os extras da ficha (metodologia, níveis…). ?previa=1 = dono/admin vê a ficha antes da aprovação.
const ehLink = (s) => /^https?:\/\//i.test(s || "");
const rotuloSocial = (s) => (/linkedin\./i.test(s) ? "LinkedIn" : /instagram\./i.test(s) ? "Instagram" : "Rede social");

// 🎓 ESCOLA PARCEIRA COM BOLSA (22/10/2026, piloto Times Idiomas). /capacitacao/:slug
// A escola não dá aula grátis nem usa a sala do eaiRH: oferece BOLSA no curso dela. O candidato lê as condições
// ANTES do clique, marca o aceite (LGPD art. 7º, I) e o eaiRH repassa só nome, e-mail e telefone à escola.
// ⚠️ Regra do Nelson (call 19/10): este texto NUNCA associa o curso a vaga/emprego nem promete contratação.
// O e-mail da escola não vem da API e nunca aparece aqui.
export default function ParceiroBolsaPage() {
  const { slug } = useParams();
  const { user } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const previa = new URLSearchParams(location.search).get("previa") === "1";
  const avaliar = new URLSearchParams(location.search).get("avaliar") === "1";   // link do e-mail "como foi?"
  const [p, setP] = useState(null);
  const [naoAchou, setNaoAchou] = useState(false);
  const [meu, setMeu] = useState(null);
  const [abrindo, setAbrindo] = useState(false);
  const [telefone, setTelefone] = useState("");
  const [aceite, setAceite] = useState(false);
  const [enviando, setEnviando] = useState(false);
  const [erro, setErro] = useState("");
  const [pronto, setPronto] = useState(null);
  const [retirado, setRetirado] = useState(null);
  const [porContato, setPorContato] = useState(false);   // professor com agenda: preferiu o pedido de contato

  // piloto: fora do índice (o servidor também manda X-Robots-Tag)
  useEffect(() => {
    const m = document.createElement("meta"); m.name = "robots"; m.content = "noindex, nofollow";
    document.head.appendChild(m);
    return () => { document.head.removeChild(m); };
  }, []);

  useEffect(() => {
    setP(null); setNaoAchou(false);
    obterParceiroBolsa(slug, previa).then((d) => {
      setP(d);
      document.title = d.tipo === "prof" ? `${d.nome}: aula experimental grátis de ${d.curso} · eaiRH` : `${d.nome}: ${d.curso} com ${d.percentualBolsa}% de bolsa · eaiRH`;
    }).catch(() => setNaoAchou(true));
  }, [slug, previa, user]);

  useEffect(() => {
    if (!user) { setMeu(null); return; }
    meuInteresseBolsa(slug).then((d) => { setMeu(d); setTelefone(d.telefone || ""); }).catch(() => setMeu(null));
  }, [slug, user, retirado]);

  // veio do e-mail "como foi?": rola até o quadro do pedido (onde fica a avaliação)
  useEffect(() => {
    if (avaliar && meu?.jaPediu) document.getElementById("meu-pedido")?.scrollIntoView({ behavior: "smooth", block: "center" });
  }, [avaliar, meu?.jaPediu]);

  if (naoAchou) return <NotFoundPage />;
  if (!p) return <div className="min-h-screen bg-background"><Header /><p className="p-8 text-gray-400">Carregando…</p></div>;

  const clicarInteresse = () => {
    setErro("");
    if (!user) {
      navigate(`/entrar?redirect=${encodeURIComponent(`/capacitacao/${slug}`)}&motivo=${encodeURIComponent(p.tipo === "prof" ? `Entre para pedir a aula grátis com ${p.nome}.` : `Entre para pedir o contato da escola ${p.nome}.`)}`);
      return;
    }
    if (!meu) { setErro("Carregando seus dados… tente de novo em instantes."); return; }
    if (!meu.podePedir) { setErro("O pedido de contato é para contas de candidato."); return; }
    setAbrindo(true);
  };

  const enviar = async () => {
    setErro(""); setEnviando(true);
    try {
      const r = await pedirInteresseBolsa(slug, { consentimento: aceite, telefone });
      setPronto(r); setAbrindo(false);
      setMeu((m) => ({ ...(m || {}), jaPediu: true, pedidoEm: new Date().toISOString() }));
    } catch (e) {
      setErro(e.message);
      if (e.jaPediu) { setAbrindo(false); setMeu((m) => ({ ...(m || {}), jaPediu: true })); }
    }
    setEnviando(false);
  };

  const prof = p.tipo === "prof";
  const x = p.extras || {};
  const onde = { sala: "Online, na sala de vídeo do eaiRH", propria: "Online, na plataforma do professor", presencial: `Presencial${p.cidade ? ` (${p.cidade})` : ""}` };
  const condicoes = (prof
    ? [
      ["Aula experimental", x.aulaGratisMin ? `${x.aulaGratisMin} min, grátis, sem cartão e sem contrato` : "Grátis, sem cartão e sem contrato"],
      ["Desconto para quem vem do eaiRH", x.descontoPct ? `${x.descontoPct}%` : null],
      ["Valor do curso", x.valorCurso],
      ["Onde são as aulas", (x.ondeDaAula || []).map((o) => onde[o]).filter(Boolean).join("; ")],
      ["Duração do curso", p.duracao],
      ["Frequência", p.frequencia],
      ["Horário de atendimento", p.horarios],
      ["Primeiro contato", p.primeiroContato],
    ]
    : [
      ["Bolsa", `${p.percentualBolsa}% de desconto${p.bolsaVigencia ? `, ${p.bolsaVigencia}` : ""}`],
      ["Duração do curso", p.duracao],
      ["Horários da escola", p.horarios],
      ["Frequência", p.frequencia],
      ["Cancelamento", p.cancelamento],
      ["Quem pode ter a bolsa", p.elegibilidade],
      ["Teste de nível grátis", x.testeNivelGratis === true ? "Sim" : x.testeNivelGratis === false ? "Não" : null],
      ["Preço", x.precoAPartir ? `A partir de ${x.precoAPartir}` : null],
      ["Endereço", x.online100 ? "100% online" : x.endereco ? `${x.endereco}${p.cidade ? ` · ${p.cidade}` : ""}` : null],
      ["Primeiro contato", p.primeiroContato],
    ]).filter(([, v]) => v);
  const sobreCurso = [
    ["Metodologia", (x.metodologias || []).join(" · ")],
    ["Níveis", (x.niveis || []).join(", ")],
    ["Modalidade", x.modalidade],
    ["Formato", x.formato],
    ["Diferenciais", x.diferenciais],
    ["Certificações", x.certificacoes],
  ].filter(([, v]) => v);
  const quem = prof ? p.nome : `a escola ${p.nome}`;
  const irEntrar = () => navigate(`/entrar?redirect=${encodeURIComponent(`/capacitacao/${slug}`)}&motivo=${encodeURIComponent(`Entre para pedir a aula grátis com ${p.nome}.`)}`);
  const comAgenda = prof && p.agendaId && !p.previa && !porContato && !meu?.jaPediu;

  return (
    <div className="min-h-screen bg-background">
      <Header />
      <main className="max-w-3xl mx-auto px-4 md:px-6 py-8">
        {p.previa ? (
          <p className="mb-4 rounded-xl bg-sky-50 border border-sky-200 text-sky-900 text-sm px-3 py-2">
            <b>Prévia:</b> é assim que o candidato vai ver a página depois da aprovação do eaiRH. O botão não funciona na prévia.
          </p>
        ) : !p.ativo && (
          <p className="mb-4 rounded-xl bg-amber-50 border border-amber-200 text-amber-900 text-sm px-3 py-2">
            Prévia: esta página ainda está <b>desativada</b> e não aparece para o público.
          </p>
        )}
        <div className="flex gap-4 items-start">
          {p.logoUrl && <img src={urlApi(p.logoUrl)} alt={`Logotipo de ${p.nome}`} className="w-16 h-16 md:w-20 md:h-20 rounded-xl object-cover border border-gray-200 bg-white shrink-0" />}
          <div className="min-w-0">
            <p className="text-xs font-semibold uppercase tracking-wide text-gray-500">{prof ? "Professor(a) parceiro(a) do eaiRH" : "Escola parceira do eaiRH"}{p.cidade ? ` · ${p.cidade}` : ""}</p>
            <h1 className="text-2xl md:text-3xl font-bold text-text mt-1">{prof ? `${p.nome}: aula experimental grátis de ${p.curso}` : `${p.nome}: ${p.curso} com ${p.percentualBolsa}% de bolsa`}</h1>
          </div>
        </div>
        {p.sobre && <p className="text-gray-700 mt-3">{p.sobre}</p>}
        {(p.site || p.instagram) && (
          <p className="text-sm mt-2 flex flex-wrap gap-3">
            {p.site && <a href={ehLink(p.site) ? p.site : `https://${p.site}`} target="_blank" rel="noopener noreferrer" className="text-primary font-semibold">{prof ? "Site" : "Site da escola"}</a>}
            {p.instagram && (ehLink(p.instagram)
              ? <a href={p.instagram} target="_blank" rel="noopener noreferrer" className="text-primary font-semibold">{rotuloSocial(p.instagram)}</a>
              : <a href={`https://instagram.com/${p.instagram.replace(/^@/, "")}`} target="_blank" rel="noopener noreferrer" className="text-primary font-semibold">@{p.instagram.replace(/^@/, "")}</a>)}
          </p>
        )}

        <section className="mt-6 bg-white rounded-2xl shadow-sm p-5">
          <h2 className="font-bold text-text text-lg">Condições</h2>
          <dl className="mt-3 divide-y text-sm">
            {condicoes.map(([k, v]) => (
              <div key={k} className="py-2.5 sm:grid sm:grid-cols-3 sm:gap-4">
                <dt className="font-semibold text-gray-700">{k}</dt>
                <dd className="text-gray-800 sm:col-span-2 mt-0.5 sm:mt-0">{v}</dd>
              </div>
            ))}
          </dl>
        </section>

        {sobreCurso.length > 0 && (
          <section className="mt-4 bg-white rounded-2xl shadow-sm p-5">
            <h2 className="font-bold text-text text-lg">Sobre o curso</h2>
            <dl className="mt-3 divide-y text-sm">
              {sobreCurso.map(([k, v]) => (
                <div key={k} className="py-2.5 sm:grid sm:grid-cols-3 sm:gap-4">
                  <dt className="font-semibold text-gray-700">{k}</dt>
                  <dd className="text-gray-800 sm:col-span-2 mt-0.5 sm:mt-0">{v}</dd>
                </div>
              ))}
            </dl>
          </section>
        )}

        {!p.previa && <NumerosParceiro numeros={p.numeros} prof={prof} />}

        <section className="mt-4 bg-white rounded-2xl shadow-sm p-5 text-sm text-gray-700">
          <h2 className="font-bold text-text text-lg">Como funciona</h2>
          {prof && p.agendaId ? (
            <>
              <ol className="mt-2 list-decimal pl-5 space-y-1.5">
                <li>Você escolhe um horário livre e pede a aula experimental grátis.</li>
                <li>{p.nome} aprova ou sugere outro horário em até 24 horas.</li>
                <li>Confirmada, você recebe por e-mail o link pessoal da sala de vídeo do eaiRH e o convite na agenda. A aula é no navegador, sem instalar nada.</li>
                <li>Depois da aula, você decide se quer continuar.</li>
              </ol>
              <p className="mt-3 text-gray-600">A aula experimental é grátis, sem cartão e sem contrato. Se você seguir com o curso, valor e pagamento são combinados diretamente com o professor.</p>
            </>
          ) : prof ? (
            <>
              <ol className="mt-2 list-decimal pl-5 space-y-1.5">
                <li>Você clica em <b>Pedir aula grátis</b> e autoriza o eaiRH a passar para {p.nome} <b>somente</b> o seu nome, e-mail e telefone.</li>
                <li>{p.nome} entra em contato com você para combinar o dia e o horário da aula experimental.</li>
                <li>Depois da aula, você decide se quer continuar.</li>
              </ol>
              <p className="mt-3 text-gray-600">A aula experimental é grátis, sem cartão e sem contrato. Se você seguir com o curso, valor e pagamento são combinados diretamente com o professor.</p>
            </>
          ) : (
            <>
              <ol className="mt-2 list-decimal pl-5 space-y-1.5">
                <li>Você clica em <b>Tenho interesse</b> e autoriza o eaiRH a passar para a escola <b>somente</b> o seu nome, e-mail e telefone.</li>
                <li>A escola {p.nome} entra em contato com você.</li>
                <li>Nessa conversa, a escola avalia a elegibilidade e apresenta as condições comerciais. Você decide se quer seguir.</li>
              </ol>
              <p className="mt-3 text-gray-600">A matrícula, o contrato e o pagamento são combinados diretamente com a escola. Pedir o contato não obriga você a nada.</p>
            </>
          )}
        </section>

        <section id="meu-pedido" className="mt-4 bg-white rounded-2xl shadow-sm p-5">
          {retirado && !meu?.jaPediu && (
            <p className="mb-3 rounded-xl bg-slate-50 border border-gray-200 text-gray-700 text-sm p-3">
              Pronto: seu pedido foi excluído{retirado.parceiroAvisado ? ` e avisamos ${quem} para apagar os seus dados` : `. Vamos avisar ${quem} para apagar os seus dados`}.
            </p>
          )}
          {comAgenda ? (
            <AgendaAulaGratis agendaId={p.agendaId} nome={p.nome} curso={p.curso} user={user} ehCandidato={user?.tipo === 0}
              onEntrar={irEntrar} onPreferirContato={() => { setPorContato(true); clicarInteresse(); }} />
          ) : pronto ? (
            <div className="rounded-xl bg-green-50 border border-green-200 text-green-900 text-sm p-4">
              <p className="font-bold">Pronto! Seu {prof ? "pedido" : "interesse"} foi enviado {prof ? "a" : "à escola"} {pronto.escola}.</p>
              <p className="mt-1">{pronto.primeiroContato ? `Primeiro contato: ${pronto.primeiroContato}` : (prof ? "O professor vai entrar em contato com você." : "A escola vai entrar em contato com você.")}</p>
              <p className="mt-1">Fique de olho no seu e-mail e no telefone que você informou.</p>
            </div>
          ) : meu?.jaPediu ? (
            <div className="rounded-xl bg-green-50 border border-green-200 text-green-900 text-sm p-4">
              <p className="font-bold">Você já pediu o contato {prof ? "de" : "da escola"} {p.nome}{meu.pedidoEm ? ` em ${new Date(meu.pedidoEm).toLocaleDateString("pt-BR")}` : ""}.</p>
              <p className="mt-1">{prof ? "O professor" : "A escola"} fala com você pelos dados que você autorizou. Não é preciso pedir de novo.</p>
              {meu.minhaAvaliacao ? (
                <p className="mt-2">Sua avaliação: <b>{meu.minhaAvaliacao.nota} de 5</b>{meu.minhaAvaliacao.status === "pendente" ? " (o comentário aparece depois da moderação)" : ""}. Obrigado!</p>
              ) : meu.podeAvaliar ? (
                <AvaliarParceiro slug={slug} prof={prof} nome={p.nome} abrirJa={avaliar}
                  onFeito={(a) => { setMeu((m) => ({ ...m, podeAvaliar: false, minhaAvaliacao: a })); obterParceiroBolsa(slug).then(setP).catch(() => {}); }} />
              ) : null}
              <div><RetirarAutorizacao slug={slug} quem={quem} compartilhado={meu.compartilhado}
                onRetirado={(r) => { setRetirado(r); setPronto(null); setMeu((m) => ({ ...m, jaPediu: false, minhaAvaliacao: null })); obterParceiroBolsa(slug).then(setP).catch(() => {}); }} /></div>
            </div>
          ) : !abrindo ? (
            <div className="flex flex-col items-start gap-2">
              <button onClick={clicarInteresse} disabled={p.previa} className="bg-accent text-white font-bold rounded-lg px-5 py-2.5 disabled:opacity-60">{prof ? "Pedir aula grátis" : "Tenho interesse"}</button>
              <p className="text-xs text-gray-500">{user ? "Antes de enviar, você confere os dados e autoriza o compartilhamento." : "Você entra na sua conta do eaiRH e, antes de enviar, confere os dados e autoriza o compartilhamento."}</p>
            </div>
          ) : (
            <div className="text-sm">
              <h2 className="font-bold text-text text-lg">Conferir e autorizar</h2>
              <p className="text-gray-600 mt-1">Só estes dados vão para {quem}. Nada do seu currículo ou perfil é compartilhado.</p>
              <dl className="mt-3 space-y-2">
                <div><dt className="text-xs text-gray-500">Nome</dt><dd className="font-semibold">{meu?.nome}</dd></div>
                <div><dt className="text-xs text-gray-500">E-mail</dt><dd className="font-semibold break-all">{meu?.email}</dd></div>
                <div>
                  <dt className="text-xs text-gray-500">Telefone (com DDD)</dt>
                  <dd><input value={telefone} onChange={(e) => setTelefone(e.target.value)} inputMode="tel" maxLength={30}
                    placeholder="(11) 91234-5678" className="w-full sm:w-64 border border-gray-300 rounded-lg px-3 py-1.5 mt-0.5" /></dd>
                </div>
              </dl>
              <label className="mt-4 flex items-start gap-2 rounded-xl border border-gray-200 bg-slate-50 p-3 cursor-pointer">
                <input type="checkbox" checked={aceite} onChange={(e) => setAceite(e.target.checked)} className="mt-1" />
                <span className="text-gray-700">{p.textoConsentimento}</span>
              </label>
              {erro && <p className="text-red-600 mt-2">{erro}</p>}
              <div className="flex flex-wrap gap-2 mt-4">
                <button onClick={() => { setAbrindo(false); setErro(""); }} className="bg-slate-100 font-bold rounded-lg px-4 py-2">Voltar</button>
                <button disabled={!aceite || enviando || telefone.replace(/\D/g, "").length < 10} onClick={enviar}
                  className="bg-accent text-white font-bold rounded-lg px-4 py-2 disabled:opacity-40">{enviando ? "Enviando…" : "Enviar meu interesse"}</button>
              </div>
            </div>
          )}
          {erro && !abrindo && <p className="text-red-600 text-sm mt-2">{erro}</p>}
        </section>

        {!p.previa && <AvaliacoesParceiro avaliacoes={p.avaliacoes} nome={p.nome} />}

        <p className="text-[11px] text-gray-400 mt-4">
          Condições definidas por {quem}{prof ? "" : " e sujeitas ao contrato dela"}. Você pode retirar a autorização e excluir seu pedido
          a qualquer momento, aqui ou em <Link to="/conta" className="underline">Minha conta</Link>; dúvidas sobre seus dados: contato@eairh.com.br. Veja a <Link to="/privacidade" className="underline">política de privacidade</Link>.
        </p>
      </main>
    </div>
  );
}
